module.exports = function UpdateSourceUpdateResponse(error) {
    this.error = error;
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/topic-update/update-source-update-response.js
// module id = 341
// module chunks = 1